import { VisitTypes } from "../Utility/Constants";
import { apiRequest } from "./ApiUtility";

export async function getVisits(authContext, filters) {
  const url = `/api/visit/facility/${authContext?.selectedFacility?.id}`;
  const data = {
    from: filters?.from,
    to: filters?.to,
    statusList: filters?.statusList,
    physicianId: filters?.physicianId,
  };
  return await apiRequest("post", url, authContext, data);
}

export async function getVisit(authContext, visitId) {
  const url = `/api/visit/${visitId}`;
  return await apiRequest("get", url, authContext);
}

export async function getAppointment(authContext, appointmentId) {
  const url = `/api/appointment/${appointmentId}`;
  // Note: Using authContext.auth.authToken as in original code
  const modifiedAuthContext = {
    ...authContext,
    authToken: authContext.auth.authToken
  };
  return await apiRequest("get", url, modifiedAuthContext);
}

export async function getAvailableSlots(dates, authContext, physicianId, serviceId) {
  const url = "/api/appointment/availableslots";
  
  // Return early if required parameters are missing
  if (!dates || !authContext || !physicianId) {
    return { isSuccess: false, data: {} };
  }
  
  const data = {
    physicianId: physicianId,
    dates: dates,
    serviceId: serviceId,
  };
  
  const result = await apiRequest("post", url, authContext, data);
  
  // Maintain original logic for isSuccess field
  return {
    isSuccess: result.isSuccess ? result.isSuccess : false,
    data: result.data
  };
}

export async function createNewVisit(
  authContext,
  patientId,
  physicianId,
  scheduledStartDateTime,
  scheduledEndDateTime,
  notes,
  visitType,
  clinicalServiceId,
  onwardTravelTimeInMins,
  returnTravelTimeInMins
) {
  const url = "/api/visit";
  const data = {
    patientId,
    physicianId,
    scheduledStartDateTime,
    scheduledEndDateTime,
    onwardTravelTimeInMins,
    returnTravelTimeInMins,
    notes,
    clinicalServiceId,
    facilityId: authContext.selectedFacility.id,
    visitType,
  };
  
  return await apiRequest("post", url, authContext, data);
}

export async function updateAppointmentStatus(authContext, appointmentId, newStatus) {
  const url = `/api/appointment/updatestatus/${appointmentId}`;
  const data = {
    newStatus: newStatus,
    facilityId: authContext.auth.selectedFacility.id,
  };
  
  // Note: Using authContext.auth.authToken as in original code
  const modifiedAuthContext = {
    ...authContext,
    authToken: authContext.auth.authToken
  };
  
  return await apiRequest("put", url, modifiedAuthContext, data);
}

export async function changeVisit(
  authContext,
  visitId,
  scheduledStartDateTime,
  scheduledEndDateTime,
  patientNotes,
  clinicalServiceId,
  physicianId,
  onwardTravelTimeInMins,
  returnTravelTimeInMins
) {
  const url = `/api/visit/change/${visitId}`;
  const data = {
    scheduledStartDateTime: scheduledStartDateTime,
    scheduledEndDateTime: scheduledEndDateTime,
    physicianId: physicianId,
    patientNotes: patientNotes,
    clinicalServiceId: clinicalServiceId,
    onwardTravelTimeInMins: onwardTravelTimeInMins,
    returnTravelTimeInMins: returnTravelTimeInMins,
  };
  
  return await apiRequest("put", url, authContext, data);
}